export const PILL = '999px';
